export default "__VITE_ASSET__BcUQDX5T__"